export default __webpack_public_path__ + "static/icon-share-e9829eb9f45008dc19e3ac3973e16374.webp";